import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { navLinks } from "../data";
import { Button } from "../shared";

/**
 * Slide-down full-screen mobile menu panel.
 *
 * @param {Object} props
 * @param {boolean} props.open - whether the menu is visible
 * @param {() => void} props.onClose - called when the menu should close
 * @returns {import("react").ReactElement}
 */
export function MobileMenu(props) {
  const { open, onClose } = props;

  useEffect(() => {
    if (!open) {
      return;
    }

    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  return (
    <div
      aria-hidden={!open}
      className={`fixed inset-0 z-[110] transition-opacity duration-200 md:hidden ${
        open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        className="bg-ink/40 absolute inset-0 backdrop-blur-sm"
      />
      <div
        className={`shadow-card absolute top-0 right-0 left-0 rounded-b-[28px] bg-white p-6 transition-transform duration-300 ${
          open ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="flex justify-end">
          <button
            type="button"
            aria-label="Close menu"
            onClick={onClose}
            className="text-ink-soft hover:bg-ice hover:text-cerulean inline-flex h-10 w-10 items-center justify-center rounded-full transition"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <nav className="mt-2 mb-5 flex flex-col">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={onClose}
              className="text-ink hover:bg-crystal rounded-xl px-4 py-3.5 text-base font-medium transition"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <div className="flex flex-col gap-3">
          <Button
            variant="soft"
            href="/app/login"
            className="w-full justify-center"
            onClick={onClose}
          >
            Log In
          </Button>
          <Button
            variant="signup"
            href="/app/apply"
            className="w-full justify-center py-3!"
            onClick={onClose}
          >
            Apply to Join
          </Button>
        </div>
      </div>
    </div>
  );
}
